/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：529
 */

module.exports = {
  container: "TableDataWatch_container__1RVpj",
  wrapper: "TableDataWatch_wrapper__3KtlN",
  header: "TableDataWatch_header__2XB3L",
  name: "TableDataWatch_name__2ltVa",
  closeIconBox: "TableDataWatch_closeIconBox__2-a-G",
  actions: "TableDataWatch_actions__23X4k",
  toast: "TableDataWatch_toast__3K0cr",
  baseCell: "TableDataWatch_baseCell__2ONmz",
  gridHeaderCell: "TableDataWatch_gridHeaderCell__1i6Oe"
}
